export default {
  "shop.minStockQuantity": "最小在庫数",
  "shop.barcode": "バーコード",
  "shop.plsEnterBarcode": "バーコードを入力してください",
  "shop.taxDisplay": "税表示",
  "shop.plsEnterTaxDisplay": "税表示を入力してください",
  "shop.amount_excludingTax": "金額（税抜）",
  "shop.purchasePrice_taxIncluded": "仕入原価(税込) / 単価",
  "shop.purchasePrice_nonTax": "仕入原価(税抜) / 単価",
  "shop.consumptionTax_purchaseCost": "消費税（仕入れ原価）",
  "shop.plsUpload": "画像を選択して\nアップロードしてください",
  "shop.inventorySetting": "在庫設定",
  "shop.stockLocation": "在庫場所",
  "shop.plsEnterStockLocation": "在庫場所を入力してください",
  "shop.salesRelatedInfo": "販売関連情報",
  "shop.couponSetting": "クーポン設定",
  "shop.plsSelectDepartment": "部門を選択してください",
  "shop.productType": "販売形態",
  "shop.plsSelectProductType": "製品タイプを選択してください",
  "shop.optionSetting": "オプション設定",
  "shop.materialSetting": "材料設定",
  "shop.optionalMaterial": "オプション材料",
  "shop.plsSelectMaterial": "アイテム材料を選択してください",
  "shop.unavailableCoupon": "利用不可クーポン",
  "shop.contentsSetting": "セット内容設定",
  "shop.priceAdjustment": "価格調整",
  "shop.stock": "在庫",
  "shop.selectionRuleSetting": "選択ルール設定",
  "shop.howToChoose": "選択方法",
  "shop.anyOne": "いずれの1つ",
  "shop.eitherTwo": "いずれの2つ",
  "shop.anyThree": "いずれの3つ",
  "shop.inventoryFluctuation": "在庫変動",
  "shop.currentlyInStock": "現在在庫数",
  "shop.stockQuantity": "在庫数",
  "shop.fluctuationNum": "変動数",
  "shop.inventoryReplenishment": "在庫補充のため",
  "shop.processingDate": "処理日付",
  "shop.plsEnterNumOfFluctuations": "変動数を入力してください",
  "shop.purchasePriceUnit": "仕入れ価格 / 単位",
  "shop.purchasePriceUnit_taxIncluded": "仕入原価(税抜)/単価",
  "shop.supplier": "仕入れ先",
  "shop.plsEnterSymbols": "数字の前にプラスまたはマイナス記号をつけてください。",


  "shop.couponType": "全国共通券/劇場前売券",
  "shop.ticketTaxFee": "全国共通券の販売手数料単価",
  "shop.couponType.option1": "該当しない",
  "shop.couponType.option2": "全国共通券（ムビチケシステム連携専用）",
  "shop.couponType.option3": "全国共通券（その他）",
  "shop.couponType.option4": "劇場前売券",


  "shop.kiosk.groups.programs": "プログラム",
  "shop.kiosk.groups.goods": "グッズ",
  "shop.kiosk.groups.food": "飲食",
  "shop.kiosk.groups.memberFee": "会費",
  "shop.kiosk.groups.others": "その他",
  "shop.kiosk.groups": "劇場日報表示区分",

  "shop.productCode": "商品コード",
  "shop.productCode.p": "商品コードを入力してください",
  "shop.plsSelectWorks": "作品を選択してください",
  "shop.plsInputticketTaxFee": "全国共通券の販売手数料単価を入力してください",

  "shop.inventoryControl": "在庫管理機能利用",
  "shop.autoSoldOut": "在庫0時の自動売り切れ",
  "shop.set.autoSoldOutTips": "利用する場合、在庫管理機能を利用しているセット内容の商品の在庫が0以下になると、その商品はセット内で選択できなくなります。選べる商品が足りないアイテムがあるセットは購入できません。",
  "shop.option.utilize": "利用する",
  "shop.option.notUsed": "利用しない",
  "shop.plsSelectUseStock": "在庫管理機能利用を選択してください",

  "shop.concessionAdd.detail": "詳細情報",
  "shop.concessionAdd.detail.ticketSalesSetting": "販売関連設定",
  "shop.concessionAdd.detail.ticketSalesSetting.salesDepartment": "売上部門（帳票表示）",
  "shop.concessionAdd.addRow": "アイテムを追加する",
  "shop.description": "説明文",
  "shop.recommend": "オススメ",
  "shop.recommend.sc": "セルフレジ",
  "shop.optionName": "オプション名",
  "shop.copy": "複製",
  "shop.upload.tips": "（推薦サイズ： 300px * 200px）",
};
